'use-strict'

export default (obj, props) => {
    const objCopy = { ...obj }
    for (const prop of props) delete objCopy[prop]
    return objCopy
}